import { z } from 'zod';
import { isoDate, uuid } from '../../core/common.js';
export const fiscalYearSchema = z.object({ year: z.number().int().min(2000).max(2100) });
export const fiscalYearCloseSchema = z.object({ carryOverTaskIds: z.array(uuid).default([]), note: z.string().max(2000).optional() });
/** Meta de un nodo del plan para una vigencia (`ps_goal_targets`). */
export const goalTargetSchema = z.object({ fiscalYear: z.number().int(), target: z.number(), achieved: z.number().nullish() });
export const investmentProjectSchema = z.object({
    bpin: z.string().regex(/^\d{4,20}$/, 'El BPIN son solo dígitos').nullish(),
    mgaCode: z.string().max(40).nullish(),
    sector: z.string().max(120).nullish(),
});
const money = z.number().int().min(0);
export const financialProgressSchema = z.object({ fiscalYear: z.number().int(), appropriated: money, committed: money, obligated: money, paid: money.default(0) });
export const contractDataSchema = z.object({
    number: z.string().trim().min(1).max(60),
    object: z.string().trim().min(1).max(4000),
    value: money,
    startDate: isoDate,
    endDate: isoDate,
    secopUrl: z.string().url().nullish(),
    policies: z.array(z.object({ kind: z.string().max(80), insurer: z.string().max(120).optional(), number: z.string().max(60).optional(), expiresAt: isoDate })).max(20).default([]),
});
export const improvementOriginSchema = z.object({ origin: z.enum(['CONTRALORIA', 'CONTROL_INTERNO', 'OTRO']), auditName: z.string().max(300).optional(), sireciCode: z.string().max(60).nullish() });
export const procurementLineSchema = z.object({
    fiscalYear: z.number().int(),
    unspsc: z.string().max(40).optional(),
    description: z.string().trim().min(1).max(1000),
    estimatedValue: money,
    expectedStartMonth: z.number().int().min(1).max(12),
    modality: z.string().max(120).optional(),
});
export const IMPROVEMENT_ORIGIN_LABEL = { CONTRALORIA: 'Contraloría', CONTROL_INTERNO: 'Control Interno', OTRO: 'Otro' };
//# sourceMappingURL=schemas.js.map